var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RecycoGenericInputComponent',{attrs:{"label":_vm.label,"icon":_vm.icon,"validate":_vm.validate,"value":_vm.value}},[_c('input',_vm._b({domProps:{"value":_vm.value},on:{"input":_vm.input}},'input',_vm.$attrs,false))])}
var staticRenderFns = []

export { render, staticRenderFns }